module.exports = __webpack_public_path__ + "static/media/sfOrange.625321fb.svg";